import { en, type TranslationKeys } from './en'
import { pt } from './pt'
import { it } from './it'
import { de } from './de'
import { fr } from './fr'
import { es } from './es'

export type SupportedLanguage = 'en' | 'pt' | 'it' | 'de' | 'fr' | 'es'

const translations: Record<SupportedLanguage, TranslationKeys> = {
  en,
  pt,
  it,
  de,
  fr,
  es
}

export function getLanguageFromUrl(): SupportedLanguage {
  const urlParams = new URLSearchParams(window.location.search)

  // Support both 'lang' and 'language' parameters
  const langParam = urlParams.get('lang') || urlParams.get('language')

  if (!langParam) {
    return 'en' // Default to English
  }

  const normalizedLang = langParam.toLowerCase().substring(0, 2) as SupportedLanguage

  // Validate if language is supported
  if (translations[normalizedLang]) {
    return normalizedLang
  }

  return 'en' // Fallback to English for invalid language codes
}

export function getTranslations(language: SupportedLanguage): TranslationKeys {
  return translations[language] || translations.en
}

export function useTranslation() {
  const language = getLanguageFromUrl()
  const t = getTranslations(language)

  return { t, language }
}

export { translations }
export type { TranslationKeys }
